var ExternalType;
(function(ExternalType2) {
  ExternalType2["caxa"] = "caxa";
  ExternalType2["kujiale"] = "kujiale";
})(ExternalType || (ExternalType = {}));
var OperateType;
(function(OperateType2) {
  OperateType2["ENTER_PAGE"] = "ENTER_PAGE";
  OperateType2["APART_ORDER"] = "APART_ORDER";
  OperateType2["CHECK"] = "CHECK";
  OperateType2["SIMPLE_SPLIT_ORDER"] = "SIMPLE_SPLIT_ORDER";
  OperateType2["FULL_SPLIT_ORDER"] = "FULL_SPLIT_ORDER";
  OperateType2["GET_CHANGED_INFO"] = "GET_CHANGED_INFO";
})(OperateType || (OperateType = {}));
export { ExternalType, OperateType };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/type.js